export interface StepOption {
  value: string;
  label: string;
}

export const STEP1_OPTIONS = {
  cargo_id: [
    { value: '', label: 'Selecionar' },
    { value: '74', label: 'Proprietário(a) / Sócio(a)' },
    { value: '25', label: 'Presidente / CEO' },
    { value: '36', label: 'Administrador(a)' },
    { value: '3', label: 'Diretor(a)' },
    { value: '44', label: 'Engenheiro(a)' },
    { value: '4', label: 'Gerente' },
    { value: '81', label: 'Analista de licitação' },
    { value: '65', label: 'Assistente administrativo' },
    { value: '38', label: 'Advogado' },
    { value: '43', label: 'Contador' },
    { value: '64', label: 'Consultor(a)' },
    { value: '66', label: 'Representante' },
    { value: '172', label: 'Servidor público' },
  ],

  employee_quantity: [
    { value: '', label: 'Selecionar' },
    { value: 'até 2', label: 'até 2' },
    { value: '3 - 9', label: '3 - 9' },
    { value: '10 - 49', label: '10 - 49' },
    { value: '50 - 100', label: '50 - 100' },
    { value: 'Mais de 100', label: 'Mais de 100' },
  ],

  average_participation_bidding: [
    { value: '', label: 'Selecionar' },
    { value: 'Não participo', label: 'Não participo' },
    { value: '1 - 5', label: '1 - 5' },
    { value: '6 - 10', label: '6 - 10' },
    { value: 'Mais de 10', label: 'Mais de 10' },
  ],

  average_billing: [
    { value: '', label: 'Selecionar' },
    { value: 'Ainda não faturo com licitações', label: 'Ainda não faturo com licitações' },
    { value: 'Até R$ 100 mil', label: 'Até R$ 100 mil' },
    { value: 'de R$ 100 mil a 500 mil', label: 'de R$ 100 mil a 500 mil' },
    { value: 'De R$ 500 mil a R$ 1 milhão', label: 'De R$ 500 mil a R$ 1 milhão' },
    { value: 'De R$ 1 milhão a R$ 10 milhões', label: 'De R$ 1 milhão a R$ 10 milhões' },
    { value: 'Mais de R$ 10 milhões', label: 'Mais de R$ 10 milhões' },
  ],
} as const;
